<template>
  <div class="rich-content" v-html="sanitized"></div>
</template>

<script>
import {sanitizeRichHtml} from "@/utils/sanitizeRichHtml";

export default {
  name: "RichContent",
  props: {
    html: {
      type: String,
      default: "",
    },
  },
  computed: {
    sanitized() {
      return sanitizeRichHtml(this.html);
    },
  },
};
</script>

<style lang="scss" scoped>
.rich-content {
  color: var(--font-dark-color);
  line-height: 1.5;

  :deep(p) {
    margin: 0 0 0.75rem;
    text-indent: 0;
  }

  :deep(p:last-child) {
    margin-bottom: 0;
  }

  :deep(a) {
    color: var(--primary-green-color);

    &:hover {
      color: var(--primary-green-color-hover);
    }
  }

  :deep(ul),
  :deep(ol) {
    margin: 0 0 0.75rem 1.25rem;
    padding: 0;
  }

  :deep(li) {
    margin-bottom: 0.25rem;
  }

  :deep(img) {
    max-width: 100%;
    height: auto;
  }

  // таблицы «поле / значение» — единый вид со строками остальных вкладок
  :deep(table) {
    width: 100%;
    border-collapse: collapse;
    margin: 0.5rem 0 1rem;
  }

  :deep(td),
  :deep(th) {
    padding: 0.8rem 1rem 0.8rem 0;
    vertical-align: top;
    border-bottom: 1px solid var(--light-theme-gray-color);
    line-height: 1.45;
    text-align: left;
    font-weight: 500;
    color: var(--font-dark-color);
  }

  :deep(tr:last-child td) {
    border-bottom: none;
  }

  :deep(td:first-child) {
    color: var(--secondary-gray);
    font-weight: 400;
    width: 38%;
    padding-right: 1.5rem;
  }
}
</style>
